import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Badge } from '../../../components/Badge';
import { usePendingApprovals } from './queries';

/**
 * Was auf die Entscheidung des Angemeldeten wartet -- F3-17, K-63.
 *
 * **Der einzige Kasten der Startseite, den man nicht abwaehlen kann.** Die
 * uebrigen zeigen, wie es steht; dieser zeigt, dass jemand anderes auf einen
 * wartet. Eine Kachelauswahl, mit der sich das abschalten laesst, waere ein
 * Schalter fuer "ich moechte nicht wissen, dass ich blockiere".
 *
 * Er erscheint nur, wenn etwas ansteht -- ein dauerhaft leerer Kasten am Kopf
 * der Startseite waere Platz ohne Aussage.
 *
 * **Auch die Vertretungen stehen hier.** Der Server nimmt sie in die Liste
 * auf; ohne das waere die Vertretungsregelung eine Angabe im Stammsatz, von
 * der der Vertreter nie erfaehrt.
 */
export function ApprovalInbox() {
  const { t } = useTranslation();
  const pending = usePendingApprovals();

  const waiting = pending.data ?? [];
  if (waiting.length === 0) return null;

  return (
    <section className="card notice--vip">
      <div className="chart-card__head">
        <h2>{t('approvals.inbox', { count: waiting.length })}</h2>
        <p className="chart-card__hint">{t('approvals.inboxHint')}</p>
      </div>

      <ul className="stack">
        {waiting.map((approval) => (
          <li key={approval.id} className="row">
            <Link to="/app/tickets/$ticketId" params={{ ticketId: approval.ticket_id }}>
              {approval.subject}
            </Link>
            <Badge tone="warning">{t('approvals.stage', { stage: approval.current_stage })}</Badge>
          </li>
        ))}
      </ul>
    </section>
  );
}
